import { defined, isEmptyOrUndefined } from "common/Support";
import { asString } from "common/components/component-helpers";
import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import SearchBar from "../chrome/smart/search-bar/search-bar";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const SearchBarMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[placeholder, text], [, textValueProducer, searchActiveValueProducer]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    if (text === LOADING) return env.renderProgress();
    const onClear = () => {
        defined(textValueProducer).set("");
        if (searchActiveValueProducer !== undefined) {
            searchActiveValueProducer.set(false);
        }
    };

    const cl = env.registerSearchBarClearer();
    if (cl !== undefined) {
        cl(onClear);
    }

    return (
        <SearchBar
            placeholder={placeholder === LOADING ? "Loading…" : asString(placeholder)}
            value={asString(text)}
            onChange={e => {
                defined(textValueProducer).set(e.target.value);
                if (searchActiveValueProducer !== undefined) {
                    searchActiveValueProducer.set(!isEmptyOrUndefined(e.target.value));
                }
            }}
            onClear={onClear}
        />
    );
};
